import { render, staticRenderFns } from "./AlarmNotification.vue?vue&type=template&id=a652e614&scoped=true&"
import script from "./AlarmNotification.vue?vue&type=script&lang=js&"
export * from "./AlarmNotification.vue?vue&type=script&lang=js&"
import style0 from "./AlarmNotification.vue?vue&type=style&index=0&id=a652e614&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a652e614",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VDataTable,VDialog,VIcon,VPagination,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a652e614')) {
      api.createRecord('a652e614', component.options)
    } else {
      api.reload('a652e614', component.options)
    }
    module.hot.accept("./AlarmNotification.vue?vue&type=template&id=a652e614&scoped=true&", function () {
      api.rerender('a652e614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Sensors/model/AlarmNotification.vue"
export default component.exports